<script lang="ts">
  import type { Snippet } from 'svelte';

  type Props = {
    children: Snippet;
  };

  let { children }: Props = $props();
</script>

<a
  class="byline"
  href="https://adamsohn.com"
  target="_blank"
  rel="noopener noreferrer"
>
  adamsohn.com
</a>

<div class="layout">
  <main class="content">
    {@render children()}
  </main>
</div>

<style>
  .layout {
    min-height: 100vh;
    max-width: 1100px;
    margin: 0 auto;
  }

  .content {
    min-width: 0;
    padding: var(--space-3xl) var(--space-xl);
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .byline {
    position: fixed;
    top: var(--space-lg);
    right: var(--space-lg);
    z-index: 40;
    font-family: var(--font-sans);
    font-size: var(--text-xs);
    font-weight: var(--weight-medium);
    letter-spacing: 0.04em;
    color: var(--ink-muted);
    text-decoration: none;
    padding: 4px 8px;
    border-radius: var(--radius-sm);
    transition: color 150ms ease, background 150ms ease;
  }
  .byline:hover,
  .byline:focus-visible {
    color: var(--accent);
    background: var(--surface);
    outline: none;
  }

  @media (max-width: 900px) {
    .content {
      padding: var(--space-xl) var(--space-md) var(--space-3xl);
    }
    .byline {
      top: var(--space-sm);
      right: var(--space-sm);
    }
  }
</style>
